import type { SVGProps } from 'react';

const SvgSms = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="sms">
      <path d="M4 26.6h10.85l8.28 4.84a.75.75 0 0 0 .38.1.69.69 0 0 0 .37-.1.73.73 0 0 0 .38-.65V26.6H28a2.75 2.75 0 0 0 2.75-2.75V3.56A2.75 2.75 0 0 0 28 .81H4a2.75 2.75 0 0 0-2.71 2.75v20.29A2.75 2.75 0 0 0 4 26.6Zm-1.25-23A1.25 1.25 0 0 1 4 2.31h24a1.25 1.25 0 0 1 1.25 1.25v20.29A1.25 1.25 0 0 1 28 25.1h-4.49a.75.75 0 0 0-.75.75v3.64l-7.33-4.29a.75.75 0 0 0-.38-.1H4a1.25 1.25 0 0 1-1.25-1.25Z" />
      <path d="M7.3 10.13h17.39v1.5H7.3zM7.3 16.13h9.44v1.5H7.3z" />
    </g>
  </svg>
);

export default SvgSms;
